import { Action } from '@ngrx/store';

export enum BackButtonActionTypes {
  SetCurrentDossier = '[BackButton] Set Current Dossier',
  GoBack = '[BackButton] Go Back',
  ResetState = '[BackButton] Reset Back Button State'
}

export class SetCurrentDossier implements Action {
  readonly type = BackButtonActionTypes.SetCurrentDossier;
  constructor(public payload: number) {}
}

export class GoBack implements Action {
  readonly type = BackButtonActionTypes.GoBack;
}

export class ResetState implements Action {
  readonly type = BackButtonActionTypes.ResetState;
}

export type BackButtonActions =
  | SetCurrentDossier
  | GoBack
  | ResetState;
